export enum SHEPHERD_CARD_TYPES {
  GRID = 'grid',
  COLUMN = 'column',
  LIST = 'list',
}
